import { render, staticRenderFns } from "./QuestionApproval.vue?vue&type=template&id=63cee226"
import script from "./QuestionApproval.vue?vue&type=script&lang=ts"
export * from "./QuestionApproval.vue?vue&type=script&lang=ts"
import style0 from "./QuestionApproval.vue?vue&type=style&index=0&id=63cee226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports